const otherskills = [
  "Git",
  "Heroku",
  "Github Deployment",
  "Insomnia",
  "Robo 3T",
  "MySQL Workbench",
  "Microsoft Word",
  "Power Point",
  "Zoom",
  "Google Meet",
  "Screencastify",
];

export default otherskills;
